import { ADD_CHARACTER_PANEL_SUCCESS, GET_CHARACTER_PANELS_SUCCESS, GET_CHARACTER_PANELS_FAILURE, REMOVE_CHARACTER_PANEL_SUCCESS } from '../actionTypes';
import store from '../store';
import { showUnknownError } from './keyboard-shortcuts.actions';
import { client } from '../../services/client';
import { colyClient } from '../../services/Panel-initialisation.service';

export const updateCharacterPanelAsync = payload => dispatch => {
    const { locationName, _id } = payload;

    colyClient.room.send('doAction', {
        serviceName: 'character-panels',
        name: 'patch',
        data: {
            locationName,
            _id
        },
    })

    return new Promise((resolve, reject) => (resolve()))
}

export const removeCharacterPanelAsync = payload => dispatch => {
    const { _id } = payload;

    colyClient.room.send('doAction', {
        serviceName: 'character-panels',
        name: 'remove',
        data: {
            _id
        },
    })

    return new Promise((resolve, reject) => (resolve()))
}

export const removeCharacterPanelSuccess = payload => {
    return ({
        type: REMOVE_CHARACTER_PANEL_SUCCESS,
        payload
    })
}

export const addCharacterPanelAsync = payload => dispatch => {
    const { locationName, panelId, z, userId } = payload;

    console.log('here we go...', {
        locationName,
            panelId,
            z,
            userId
    })

    colyClient.room.send('doAction', {
        serviceName: 'character-panels',
        name: 'create',
        data: {
            locationName,
            panelId,
            z,
            userId
        },
    })

    return new Promise((resolve, reject) => (resolve()))
}

export const addCharacterPanelSuccess = payload => {
    return ({
        type: ADD_CHARACTER_PANEL_SUCCESS,
        payload
    })
}

export const getCharacterPanelsAsync = payload => dispatch => {
    return client.service('character-panels').find({ paginate: false, query: { userId: payload.userId } })
        .then((response) => {
            // response = response.map(coin => ({ ...coin, coinType: payload.coinTypes.find(type => type._id === coin.coinTypeId) }))
            dispatch(getCharacterPanelsSuccess(response));
        })
        .catch((error) => {
            dispatch(showUnknownError({ message: error.message }));
            console.error('error', error);
            throw new Error(error);
        })
}

export const getCharacterPanelsSuccess = payload => {
    return ({
        type: GET_CHARACTER_PANELS_SUCCESS,
        payload
    })
}

export const getCharacterPanelsFailure = () => ({
    type: GET_CHARACTER_PANELS_FAILURE
})
